<template>
  <modal @close="smallAlertModalHide">
    <template slot="header">
      <md-button
        class="md-simple md-danger md-just-icon md-round modal-default-button"
        @click="smallAlertModalHide"
      >
        <md-icon>clear</md-icon>
      </md-button>
      <div class="md-layout md-size-100">
        <div class="md-layout-item md-size-50">
          <md-field>
            <md-input
              v-model="filterName"
              placeholder="Tên sản phẩm"
            ></md-input>
          </md-field>
        </div>
      </div>
    </template>
    <template slot="body">
      <div class="table-products">
        <table id="customers">
          <tr class="stickHeader">
            <th>STT</th>
            <th style="width: 120px">Mã sản phẩm</th>
            <th>Tên sản phẩm</th>
            <th style="width: 120px">Ảnh</th>
            <th>Số lượng</th>
            <th>ĐVT</th>
            <th>Đơn giá</th>
            <th>Chọn</th>
          </tr>
          <tr :key="index" v-for="(item, index) in search">
            <td>{{ index + 1 }}</td>
            <td>{{ item.data.productId }}</td>
            <td>{{ item.data.name }}</td>
            <td style="text-align: center">
              <div class="image-container">
                <img :src="item.data.pictureThumbnail" class="box-image" />
              </div>
            </td>
            <td>{{ item.data.warehouse }}</td>
            <td>{{ item.data.unit }}</td>
            <td>{{ formatMoney(item.data.price) }}</td>
            <td>
              <md-checkbox
                v-if="!isChangeItem && item.data.warehouse"
                :value="item"
                v-model="productSelected"
              ></md-checkbox>
              <md-radio
                v-if="isChangeItem"
                :value="item.data"
                v-model="productReplace"
              >
              </md-radio>
              <p v-show="!item.data.warehouse">Hết hàng</p>
            </td>
          </tr>
        </table>
      </div>
    </template>
    <template slot="footer">
      <md-button class="md-simple md-danger" @click="smallAlertModalHide"
        >Hủy</md-button
      >
      <md-button class="md-success md-simple" @click="confirmAdd"
        >Hoàn tất</md-button
      >
    </template>
  </modal>
</template>
<script>
import { Modal } from "@/components";
import firebase from "@/services/firebase-init.js";
import { mapGetters } from "vuex";
export default {
  components: { Modal },
  props: ["isChangeItem", "itemChange"],
  data() {
    return {
      filterName: "",
      suggestion: [],
      db: {},
      listProducts: [],
      productSelected: [],
      productReplace: {},
    };
  },
  async created() {
    this.db = firebase.firestore();
    // this.$store.dispatch("FLAG_LOADING", true);
    this.listProducts = JSON.parse(JSON.stringify(this.$listProducts));
    if (this.accessories.length === 0) {
      await this.$store.dispatch("getAllAccessories");
    }
    this.listProducts = this.listProducts.concat(this.accessories);
    this.accessories.forEach((item) => {
      this.suggestion.push(item.data.name);
    });
  },
  methods: {
    smallAlertModalHide() {
      this.$emit("smallAlertModalHide", []);
    },
    confirmAdd() {
      if (this.isChangeItem)
        this.$emit("confirmChangeItem", {
          index: this.itemChange,
          data: this.productReplace,
        });
      else this.$emit("smallAlertModalHide", this.productSelected);
    },
  },
  computed: {
    ...mapGetters(["$listProducts", "accessories"]),
    search() {
      return this.listProducts.filter(
        (item) =>
          item.data.name
            .toLowerCase()
            .indexOf(this.filterName.toLowerCase()) !== -1
      );
    },
  },
};
</script>
<style scoped>
.table-products {
  max-height: 50vh;
  overflow-y: scroll;
  border-radius: 10px;
  border: rgb(235, 235, 235) solid 1px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
#customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#customers td,
#customers th {
  border: 1px solid #ddd;
  padding: 8px;
  max-width: 20vh;
}

#customers tr:nth-child(even) {
  background-color: #f2f2f2;
}

#customers tr:hover {
  background-color: #ddd;
}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: rgb(129, 211, 136);
  color: rgb(0, 0, 0);
  font-style: normal;
  font-weight: normal;
  position: sticky;
  top: 0;
  z-index: 10;
}
.fixed-input {
  position: fixed;
}
.image-container {
  display: inline-block;
  position: relative;
  width: 60px;
  height: 60px;
  overflow: hidden;
  border-radius: 50%;
  background: white;
}
.box-image {
  width: auto;
  height: 100%;
}
</style>
